<template>
  <ValidationObserver v-slot="{ invalid, handleSubmit }" class="height-100">
    <form @submit.prevent="handleSubmit(onSubmit)" class="height-100">
      <v-layout column justify-space-between fill-height>
        <!-- 폼 영역 시작 -->
        <v-flex>
          <p class="page-title">휴대폰 번호를 입력해 주세요.</p>
          <!-- 휴대폰 번호 -->
          <FormValidationInput
            :inputValue.sync="phone"
            :valid="{ name: 'phone', rules: 'required|phone|phone_duplicate' }"
            autofocus
            title="휴대폰 번호"
            autocomplete="tel"
            type="tel"
            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').substring(0,11)"
            placeholder="예) 01012345678"
          />
        </v-flex>

        <!-- 하단 영역 시작 -->
        <div class="page-footer-column">
          <BasicButton
            block
            large
            type="submit"
            height="52"
            :disabled="invalid"
            id="btn__6Uf2k2W9kk+mztEQixKsCQ"
          >
            다음
          </BasicButton>
        </div>
        <!-- 하단 영역 끝 -->
      </v-layout>
    </form>
  </ValidationObserver>
</template>

<script>
export default {
  components: {
    FormValidationInput: () => import('@/components/common/form/FormValidationInput.vue'),
  },
  data() {
    return {
      phone: '',
    }
  },
  methods: {
    onSubmit() {
      this.$emit('next', this.phone)
    },
  },
}
</script>
